import React  from 'react';
import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {
    Box,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import searchIcon from "../../assets/images/search-normal.svg"
import FeedbackInfo from "../feedbackInfo/FeedbackInfo";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {FeedbackService} from "./FeedbackService";
import moment from "jalali-moment";


let selectedItemId = -1
const Feedbacks = () => {
    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new FeedbackService(fundID, token, snackbar, loading)

    const [openModal, setOpenModal] = useState(false)
    const handleClickOpen = () => {
        setOpenModal(true)
    }
    const handleClose = () => {
        setOpenModal(false)
        if (needRefresh) {
            setNeedRefresh(false)
            getListDataFromServer()
        }
    }

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
        }
    }, [])


    const [pageCount, setPageCount] = useState(0);
    const [itemCount, setItemCount] = useState(0);

    const [feedbacks, setFeedbacks] = useState([]);

    const [filterType, setFilterType] = useState("full-name");
    const [filterText, setFilterText] = useState("");

    const [needRefresh, setNeedRefresh] = useState(false);

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };

    function getListDataFromServer(filter = filterText, type = filterType) {
        loading(setLoadingStateDispatch(true))
        service.getFeedbacksList(fundID, page, prepareFilter(filter, type))
            .then(response => {
                setFeedbackListData(response)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت لیست انتقادات و پیشنهادات"))
            loading(setLoadingStateDispatch(false))
        })
    }

    function prepareFilter(filter, type) {
        return type === "full-name" ? {
            "full-name": filter
        } : type === "national-code" ? {
            "national-code": filter
        } : type === "group-name" ? {
            "group-name": filter
        } : ""
    }

    function setFeedbackListData(feedbacksData) {
        setItemCount(feedbacksData.numberOfItems)
        setPageCount(feedbacksData.totalPage)
        setFeedbacks([])

        feedbacksData.data.map((item, index) => {
            setFeedbacks((prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.title,
                    item.description,
                    item.sendAt,
                    item.status,
                    item.senderFirstName,
                    item.senderLastName,
                    item.senderPhoneNumber,
                    item.senderGroupName,
                )
            ]))
        })


    }

    function prepareGroupsJsonList(id, number, title, description, sendAt, status, senderFirstName, senderLastName, senderPhoneNumber, senderGroupName) {
        return {
            id: id,
            number: number,
            title: title,
            name: `${senderFirstName} ${senderLastName}`,
            cash_group: senderGroupName,
            phoneNumber: senderPhoneNumber,
            date: moment(sendAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'),
            description: description,
            state: status === "REVIEWED" ? <span
                    style={{
                        background: "rgba(64, 215, 161, 0.35)",
                        padding: "2px 8px",
                        borderRadius: "7px"
                    }}>بررسی شده</span> :
                <span style={{
                    background: "rgba(240, 84, 84, 0.35)",
                    padding: "2px 8px",
                    borderRadius: "7px"
                }}>در حال بررسی</span>,
        }
    }

    const showEventsContent = (rowId) => {
        selectedItemId = rowId
        setOpenModal(true);
    }

    return (
        <>
            {
                <FeedbackInfo
                    openModal={openModal}
                    handleClose={handleClose}
                    selectedItemId={selectedItemId}
                    needRefresh={setNeedRefresh}
                />}
            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            انتقادات و پیشنهادات
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " انتقاد و پیشنهاد ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                </Box>
                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '0 0 1.2rem 0',
                         justifyContent: 'start',
                         alignContent: 'start',
                         alignItems: 'start'
                     }}>
                    <Grid sm={12} md={8} lg={8} xl={8} className='modalTextFieldContainer'>
                        <TextField
                            value={filterText}
                            onChange={e => {
                                setFilterText(e.target.value)
                                getListDataFromServer(e.target.value)
                            }}
                            className='w-100'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو"
                            placeholder="عبارت مورد نظر را وارد نمایید..."/>
                    </Grid>
                    <Grid sm={12} md={8} lg={4} xl={4} className='modalTextFieldContainer'>
                        <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                            <Select value={filterType} onChange={e => {
                                setFilterType(e.target.value)
                                getListDataFromServer(filterText, e.target.value)
                            }} label="جستجو بر اساس">
                                <option className="px-2 py-1" value={"full-name"}>نام و نام خانوادگی</option>
                                <option className="px-2 py-1" value={"national-code"}>کد ملی</option>
                                <option className="px-2 py-1" value={"group-name"}>نام گروه</option>
                            </Select>
                        </FormControl>
                    </Grid>

                </Box>


                <CustomTable
                    header={columns}
                    data={feedbacks}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>
    )

}

export default Feedbacks;


const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',

    },
    {
        id: 'title',
        label: 'عنوان',
        align: 'right',
    },
    {
        id: 'name',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'phoneNumber',
        label: 'شماره همراه',
        align: 'right',
    },
    {
        id: 'cash_group',
        label: 'گروه',
        align: 'right',
    }
    ,
    {
        id: 'date',
        label: 'تاریخ',
        align: 'right',
    }
    ,
    {
        id: 'description',
        label: 'توضیحات',
        align: 'right',
    }
    ,
    {
        id: 'state',
        label: 'وضعیت',
        align: 'right',
    },];